import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DiscoverBlock = makeShortcode("DiscoverBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <DiscoverBlock slots="heading, link, text" mdxType="DiscoverBlock" />
    <h3 {...{
      "id": "guides"
    }}>{`Guides`}</h3>
    <p><a parentName="p" {...{
        "href": "/creative-cloud-libraries/docs/integrate/guides/working-with-elements/"
      }}>{`Working with Library elements`}</a></p>
    <p>{`Learn all about supported libary elements, how to fetch element data, and how to create new elements in a library.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "/creative-cloud-libraries/docs/integrate/guides/configuring-events-webhooks/"
      }}>{`Configuring webhooks for Libraries Events`}</a></p>
    <p>{`Listen for updates in Libraries and get notified when users make changes.`}</p>
    <DiscoverBlock slots="heading, link, text" mdxType="DiscoverBlock" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      